import React from 'react';
import __ from 'lodash';

class DropdownSpesifikasiPrestasi extends React.Component{
    render() {
        return (
            this.props.spesifikasi.map((val, i) =>
                <option key={val.idPrestasi} value={val.idPrestasi}>{val.namaPrestasi}</option>
            )            
        )
    }
}

export default DropdownSpesifikasiPrestasi;